import { toast } from "react-toastify";
import ApiService from "../../../services/apiService";
import { Card, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container } from "reactstrap";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { schemeTitle, Configuration } from "../../../constants";
import Table from "../../table/Table";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";
import LoadingComponent from "../../lodingComponent";
import { Filter } from "react-feather";
const SchemeVillage = () => {
    const role = useAppSelector((state) => state.role.role);
    const [schemeVillage, setSchemeVillage] = useState([]);
    const navigate = useNavigate();
    const [selectedSchemeVillageId, setSelectedSchemeVillageId] = useState('');
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);



    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy,
        loading
    } = usePagination({
        endpoint: `/schemeVillage`,
        filterOn:'Scheme_Village',
        enabled:true
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])


    /* useEffect(() => {
 
         const fetchSchemeVillage = async () => {
            
             try{
                 const response = await ApiService.axiosApi('/schemevillage' ,{
                     method: 'GET',
                 }) 
 
                 if(response.success){
                     console.log(response.data);
                     setSchemeVillage(response.data);
                 }
                 else{
                     console.log(response.data.message);
                     toast.error(response.data.message);
 
                 }
             }catch(error: any){
                 toast.error(error.message);
             }
         }
         fetchSchemeVillage();
     }, [refresh]);*/

    const handleUpdate = (id: string) => {
        navigate(`/scheme-village-update/${id}`);
    }

    const handleDelete = (id: string) => {
        setSelectedSchemeVillageId(id);
        setIsDeleteModalOpen(true);
    }

    const handleDeleteSchemeVillage = async (id: string) => {
        try {
            console.log(id);
            const response = await ApiService.axiosApi(`/schemevillage/${id}`, {
                method: 'DELETE',
            });

            if (response.success) {
                console.log(response.data);
                toast.success(response.data.message);
                setIsDeleteModalOpen(false);
                setRefresh(prev => !prev);
            }
            else {
                toast.error(response.data.message);
            }
        } catch (error: any) {
            toast.error(error.message);
        }
    }
    return (
        <>
            <Breadcrumbs mainTitle={schemeTitle} parent={Configuration} />
            
                <Card>
                    <CommonCardHeader title="Scheme/Village" headClass={"pb-3"} />
                    <div className="d-flex justify-content-between">
                    <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('Scheme_Village')}>
                           <Filter/>
                       </button>
                           </div>
                        
                    </div>
                    {role === "Administrator" && (
                        <div className="d-flex justify-content-end">
                            <Button onClick={() => navigate(`/scheme-village-add`)} color="primary" className="mb-2 mx-2">Add Scheme/Village</Button>
                        </div>
                    )}
                     </div>
                     {loading?<LoadingComponent/>:<Table
                        data={data}
                        columns={[
                            { header: "Scheme/Village", accessor: "scheme_Village" },
                            { header: "Distributary/Zone", accessor: "distributary_Zone" },

                        ]}

                        buttons={[
                            { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
                            { label: "Delete", onClick: handleDelete, color: "danger" }
                        ]}
                    />}
                    
                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>
                </Card>

                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                    <ModalHeader>Delete Scheme Village</ModalHeader>
                    <ModalBody>Are you sure you want to delete this scheme village?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => handleDeleteSchemeVillage(selectedSchemeVillageId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            
        </>
    )
}

export default SchemeVillage;   
